import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../utils/apiInterceptor';
import { API_BASE_URL } from '../../utils/paths';
import { deleteSpot, updateSpot } from './savedSpotsSlice';
import { isForecastFresh } from '../../utils/forecastCache';

// spots/all/forecast
export const fetchSavedSpotsLiveData = createAsyncThunk(
  'forecast/fetchSavedSpotsLiveData',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiFetch(`${API_BASE_URL}/spots/all/live`, {
        method: 'GET',
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      return rejectWithValue({ message: error.message });
    }
  },
  {
    // Skip when every saved spot already has live data younger than the TTL
    condition: (_, { getState }) => {
      const { savedSpots, liveData } = getState();
      const spotIds = Object.keys(savedSpots.spots || {});
      return spotIds.length === 0 || spotIds.some((id) => !isForecastFresh(liveData.spots[id]));
    },
  }
);

const liveDataSlice = createSlice({
    name: 'liveData',
    initialState: {
        spots: {},
        isLoading: false,
        errors: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSavedSpotsLiveData.pending, (state) => {
                state.isLoading = true;
                state.errors = null;
            })
            .addCase(fetchSavedSpotsLiveData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.spots = action.payload;
            })
            .addCase(fetchSavedSpotsLiveData.rejected, (state, action) => {
                state.isLoading = false;
                state.errors = action.payload || { message: 'Failed to fetch all spots live data' };
            })
            .addCase(deleteSpot.fulfilled, (state, action) => {
                delete state.spots[action.payload];
            })
            // Preferences/location changed, so the cached rating is outdated
            .addCase(updateSpot.fulfilled, (state, action) => {
                delete state.spots[action.payload.id];
            });
    }
});

export default liveDataSlice.reducer